import Counter from "@/components/Counter";
import Reveal from "@/components/Reveal";
import { motion } from "framer-motion";

const stats = [
  { to: 100, suffix: "", label: "Days of R&D" },
  { to: 500, suffix: "+", label: "B2B Outreach Calls" },
  { to: 30, suffix: "+", label: "Executive Strategy Meetings" },
];

export default function Authority() {
  return (
    <section className="relative overflow-hidden py-24 md:py-32">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute left-1/2 top-1/2 h-[600px] w-[900px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-accent/[0.06] blur-[120px]" />
      </div>
      <div className="container-x">
        <div className="mx-auto max-w-3xl text-center">
          <span className="eyebrow">Market Intelligence</span>
          <h2 className="mt-6 font-display text-4xl font-bold leading-[0.95] tracking-tight text-ink md:text-6xl">
            We didn’t guess. <span className="grad-text">We called.</span>
          </h2>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.6, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="rounded-3xl border border-slate-200 bg-white p-10 text-center shadow-card"
            >
              <div className="font-display text-6xl font-bold tracking-tight text-ink md:text-7xl">
                <Counter to={s.to} suffix={s.suffix} />
              </div>
              <div className="mx-auto mt-4 h-1 w-12 rounded-full bg-accent" />
              <p className="mt-4 text-sm font-semibold uppercase tracking-wider text-ink-muted">{s.label}</p>
            </motion.div>
          ))}
        </div>

        <Reveal className="mx-auto mt-14 max-w-3xl text-center">
          <p className="text-xl font-medium leading-relaxed text-ink-soft md:text-2xl">
            “We called <span className="font-bold text-ink">500 businesses</span> to find their biggest operational leak — and engineered the <span className="grad-text font-bold">exact plug.</span>”
          </p>
          <div className="mx-auto mt-8 grid max-w-2xl gap-4 sm:grid-cols-2">
            <p className="rounded-2xl border border-slate-200 bg-white p-5 text-left text-base font-medium text-ink-soft shadow-card">
              We manufactured this product with R&amp;D lasting a <span className="font-bold text-ink">100 days.</span>
            </p>
            <p className="rounded-2xl border border-slate-200 bg-white p-5 text-left text-base font-medium text-ink-soft shadow-card">
              Held over <span className="font-bold text-ink">30+ executive meetings</span> with founders and builders to come up with a working solution.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
